import { useAuth } from "@/_core/hooks/useAuth";
import { resolveNr1OverviewRoute } from "@/lib/portalShell";
import { useEffect } from "react";
import { useLocation } from "wouter";

export default function ModuleNR1Entry() {
  const { user } = useAuth();
  const [, setLocation] = useLocation();
  const userRole = typeof user?.role === "string" ? user.role : "";
  const overviewRoute = resolveNr1OverviewRoute(userRole);

  useEffect(() => {
    setLocation(overviewRoute);
  }, [overviewRoute, setLocation]);

  return null;
}
